
import React, { useState, useEffect, useRef, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
    Container,
    Button,
    FormControlLabel,
    Checkbox,
    CardContent,
    Typography,
    CircularProgress,
    Snackbar,
    Select,
    Menu,
    MenuItem,
    Grid,

    //  ADDED imports for Dialog-based approval flow
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    FormGroup,
    IconButton
} from "@material-ui/core";
import Card from "@material-ui/core/Card";
import { useSelector } from "react-redux";
import { useLazyQuery } from "@apollo/client";
import Grow from "@material-ui/core/Grow";
import Axios from "axios";
import { getBaseURL } from "../../baseURL";
import MuiAlert from "@material-ui/lab/Alert";
import gql from "graphql-tag";
import { Form } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import LinearProgress from "@material-ui/core/LinearProgress";
import Box from "@material-ui/core/Box";
import CancelImage from "../../img/cancel.png";
import "../miscellaneous/File.css";
import { UploaderComponent } from "@syncfusion/ej2-react-inputs";
import * as lodash from "lodash";
import Paper from "@material-ui/core/Paper";
import clsx from "clsx";
import "../miscellaneous/File.css";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Tooltip } from "@material-ui/core/";
import { useMsal } from "@azure/msal-react";


export const Files = () => {
    const useStyles = makeStyles((theme) => ({
        root: {
            padding: theme.spacing(1, 2),
        },
        fileCard: {
            width: "32%",
            height: "auto",
            display: "inline-block",
            marginBottom: "30px",
            "&:hover": {
                border: `1px solid ${theme.palette.primary.main}`,
            },
            "@media (max-width: 767px)": {
                width: "100%",
                paddingRight: "0",
                height: "auto",
            },
        },
        griditem: {
            "@media (max-width: 767px)": {
                width: "100%",
                marginTop: "15px",
            },
        },
        addFileButton: {
            right: "48px",
            position: "absolute",
        },
        cards: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            marginTop: "20px",
            "@media (max-width: 767px)": {
                width: "100%",
            },
        },
        cardLoading: {
            backgroundColor: "#cccccc",
            color: "#ffffff",
        },
        cardNotLoading: {
            backgroundColor: "#ffffff",
            color: "#000000",
            border: "1px solid transparent",
        },
        paragraphText: {
            textAlign: "justify",
            padding: "20px 10px 20px 10px",
            fontSize: "16px",
        },
        spanText: {
            color: "#140a9a",
        },
        Verbiage: {
            backgroundColor: "#1A0D91",
            color: "#ffffff",
            padding: "30px",
            marginTop: "30px",
            borderRadius: "6px",
            maxWidth: "800px",
            marginLeft: "auto",
            marginRight: "auto",
            textAlign: "center",
            alignItems: "center",
            justifyContent: "center",
        },
        //  ADDED: minor common button style for the new button
        button: {
            fontWeight: 600,
            marginLeft: 12,
        },
    }));

    const classes = useStyles();
    const currentUser = useSelector((state) => state.auth);
    const [userCompanies, setUserCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState();
    const [companyFiles, setCompanyFiles] = useState([]);
    const [loadingFiles, setLoadingFiles] = useState(false);
    const [useremail, setuserEmail] = useState("");
    const [UserId, setUserId] = useState("");
    const [loadingCompanies, setLoadingCompanies] = useState(false);
    const [firstUpload, setFirstUpload] = useState(false);

    const [batchGuid, setBatchGuid] = useState(null);
    const [fileGuidMap, setFileGuidMap] = useState(new Map());
    const [menuAnchorById, setMenuAnchorById] = useState({});
    const [customFileName, setCustomFileName] = useState("");
    const [fileNameError, setFileNameError] = useState("");
    
    const { instance, accounts } = useMsal();
const tokenRef = useRef(currentUser.jwtIdToken.idToken);
const firstUploadRef = useRef(false);

useEffect(() => {
    tokenRef.current = currentUser.jwtIdToken.idToken;
}, [currentUser.jwtIdToken.idToken]);

const getFreshToken = async () => {
    try {
        const res = await instance.acquireTokenSilent({
            account: accounts[0],
            scopes: ["User.Read"],
            forceRefresh: true,
        });
        tokenRef.current = res.idToken;
        return res.idToken;
    } catch (e) {
        throw new Error("Your session has expired. Please sign in again.");
    }
};
    const config = {
        headers: { Authorization: "Bearer " + tokenRef.current},
        timeout: 24000000,
    };

    const GET_USER_COMPANIES = gql`
    query GetUserCompanies($userId: String, $state: Boolean) {
      userCompanies(userId: $userId, state: $state) {
        state
        company {
          id
          name
        }
      }
    }
  `;

    const GET_COMPANY_FILES = gql`
    query GetUserFiles($companyId: Int, $expirationStartDate: DateTime) {
      file(companyId: $companyId, expirationStartDate: $expirationStartDate) {
        id
        companyId
        fileName
        originalFileNames
        dateUploaded
        expirationDate
        downloading
        encryptedPassword
      }
    }
  `;



    const [showProgress, setShowProgress] = useState(false);
    const [counter, setCounter] = useState(1);
    const [fileToBeUpload, setFileToBeUpload] = useState({});
    const [progress, setProgress] = useState(0);
    const [fileGuid, setFileGuid] = useState([]);
    const [fileName, setfileName] = useState("");
    const [fileType, setfileType] = useState("");
    const [fileSize, setFileSize] = useState(0);
    const [chunkCount, setChunkCount] = useState(0);

    const [getUserCompanies, userCompaniesQueryResults] =
        useLazyQuery(GET_USER_COMPANIES);
    const [getCompanyFiles, companyFilesQueryResults] =
        useLazyQuery(GET_COMPANY_FILES);




    const [checkedCompanies, setCheckedCompanies] = useState(false);
    const [checkedCompanyFiles, setCheckedCompanyFiles] = useState(false);
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [errorSnackBarOpen, setErrorSnackBarOpen] = useState(false);
    const [errorSnackBarText, setErrorSnackBarText] = useState("");
    const [uploadFiles, setUploadFiles] = useState(false);
    const [files, setFiles] = useState([]);
    const [selectAllChecked, setSelectAllChecked] = useState(false);
    const [downloadAllDisabled, setDownloadAllDisabled] = useState(true);
    const [checkedIds, setCheckedIds] = useState([]); // Store checked IDs here

    //  ADDED: extra states needed by the dialog flow
    const [openUploadDialog, setOpenUploadDialog] = useState(false);
    const uploaderRef = useRef(null); // dialog uploader ref (separate)
    const [submitting, setSubmitting] = useState(false);
    const [businessReason, setBusinessReason] = useState("");
    const [recipientEmails, setRecipientEmails] = useState([]);
    const [selectedRecipients, setSelectedRecipients] = useState([]);
    const [attemptedSubmit, setAttemptedSubmit] = useState(false);
    const [selectedCompanyName, setSelectedCompanyName] = useState(""); // for payload

    const handleErrorSnackbarClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setErrorSnackBarOpen(false);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setSnackBarOpen(false);
    };

    const Alert = (props) => {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    };


    const handleCompanyChange = (event) => {
        const companyIdInt = Number(event.target.value);
        console.log("Company changed:", companyIdInt);

        // Find the selected company object
        const selectedCompanyObj = userCompanies.find(
            (item) => Number(item.company.id) === companyIdInt
        );

        const companyName = selectedCompanyObj ? selectedCompanyObj.company.name : "";

        // Save both ID and Name in state
        setSelectedCompany(companyIdInt);
        setSelectedCompanyName(companyName);
        setLoadingFiles(true);


        Promise.all([
            // Refetch company files
            companyFilesQueryResults.refetch({
                companyId: companyIdInt,
                expirationStartDate: new Date(),
            }),



        ])
            .catch((err) => {
                console.error("Company change flow failed:", err);
            })
            .finally(() => {
                setLoadingFiles(false);
            });
    };

    useEffect(() => {
        if (userCompanies && userCompanies.length < 1 && !checkedCompanies) {
            getUserCompanies({
                variables: { userId: currentUser.jwtIdToken.uniqueId, state: true },
            });
            setCheckedCompanies(true);
        }

        if (
            userCompaniesQueryResults.data &&
            userCompaniesQueryResults.data.userCompanies !== userCompanies
        ) {
            setUserCompanies(userCompaniesQueryResults.data.userCompanies);

            if (userCompaniesQueryResults.data.userCompanies.length > 0) {
                const first = userCompaniesQueryResults.data.userCompanies[0];
                setSelectedCompany(first.company.id);
                setSelectedCompanyName(first.company.name);
            }
        }

        if (
            selectedCompany &&
            companyFilesQueryResults &&
            companyFilesQueryResults.data &&
            companyFilesQueryResults.data.file != companyFiles
        ) {
            if (!companyFilesQueryResults.loading) {
                setCompanyFiles(companyFilesQueryResults.data.file);
            }
        }

        if (
            userCompanies &&
            userCompanies.length > 0 &&
            companyFiles.length < 1 &&
            selectedCompany &&
            !checkedCompanyFiles
        ) {
            getCompanyFiles({
                variables: {
                    companyId: selectedCompany,
                    expirationStartDate: new Date(),
                },
            });
            setCheckedCompanyFiles(true);

            if (companyFilesQueryResults.data && companyFilesQueryResults.data.file) {
                setCompanyFiles(companyFilesQueryResults.data.file);
            }
        }

    });

    useEffect(() => {
        if (selectedCompany) {
            Axios.get(`${getBaseURL()}files/getCompanyEmails/${selectedCompany}`, config)
                .then((response) => {
                    console.log("API Response:", response.data);
                    const emails = (response.data || [])
                        .map((item) => item.email)
                        .filter((email) => email && email.trim() !== "");
                    setRecipientEmails(emails);
                    setSelectedRecipients([]);
                })
                .catch((err) => {
                    console.error("Failed to load emails:", err);
                    setRecipientEmails([]); // Clear emails on error
                })
        }
    }, [selectedCompany]);
    useEffect(() => {
        if (currentUser && currentUser.user.userPermissions) {
            try {
                if (
                    currentUser.user.userPermissions.find(
                        (p) => p.permission.permissionName === "Upload Files"
                    ).state
                ) {
                    setUploadFiles(true);
                    setUserId(currentUser.aadResponse.account.accountIdentifier);
                    setuserEmail(currentUser.aadResponse.account.userName);
                    console.log("upload files true");
                }
            } catch { }
        }
    }, [currentUser]);

    const asyncSettings = {
        saveUrl: `${getBaseURL()}files/fileupload/${selectedCompany}`,
        chunkSize: 25000000,
        retryCount: 5,
        retryAfterDelay: 2000,
    };
    const fileKey = (f) => `${f.name}::${f.size}`;

    const ensureFileGuid = (fileObj) => {
        const key = fileKey(fileObj);
        let guid = fileGuidMap.get(key);
        if (!guid) {
            guid = uuidv4();
            setFileGuidMap((prev) => {
                const next = new Map(prev);
                next.set(key, guid);
                return next;
            });
        }
        return guid;
    };
    const onDialogFileRemove = (args) => {
        // Remove stale fileGuid mapping for the removed file
        try {
            const key = fileKey(args.fileData);
            setFileGuidMap(prev => {
                const next = new Map(prev);
                next.delete(key);
                return next;
            });
        } catch { }

        // If no files left after this removal, reset batch state
        setTimeout(() => {
            const remaining = uploaderRef.current?.filesData?.length || 0;
            if (remaining === 0) resetBatchState();
        }, 0);

    };

    const resetBatchState = () => {
        setBatchGuid(uuidv4());
        setFirstUpload(false);
        firstUploadRef.current = false;
        setFileGuidMap(new Map());
    };

    const onDialogClear = () => {
        resetBatchState();
    };



    const onFilesUploading = (args) =>
        {
    args.currentRequest.setRequestHeader("Authorization", `Bearer ${tokenRef.current}`);
    const fg = ensureFileGuid(args.fileData);
    args.customFormData = [{ batchGuid: batchGuid }, { fileGuid: fg }];
    if (!firstUploadRef.current) {
        args.customFormData.push({ "init-batch": 1 });
        firstUploadRef.current = true;
        setFirstUpload(true);
    }
};

    const onChunkUpload = (args) => {
    args.currentRequest.setRequestHeader("Authorization", `Bearer ${tokenRef.current}`);
    const fg = ensureFileGuid(args.fileData);
    args.customFormData = [{ batchGuid: batchGuid }, { fileGuid: fg }];
    if (!firstUploadRef.current) {
        args.customFormData.push({ "init-batch": 1 });
        firstUploadRef.current = true;
        setFirstUpload(true);
    }
};

    const onSelect = (args) => {
        // Filter out .zip files
        const invalidFiles = args.filesData.filter(file =>
            file.type === "application/zip" || file.name.toLowerCase().endsWith(".7z") || file.name.toLowerCase().endsWith(".gz") || file.name.toLowerCase().endsWith(".zip") || file.type === "application/x-zip-compressed" || file.type === "multipart/x-zip"

        );

        if (invalidFiles.length > 0) {
            // Remove invalid files from the selection
            args.cancel = true;
            alert("ZIP files are not allowed.");
        }
        const containsFolder = args.filesData.some(f => {
            return (!f.type && f.size % 4096 === 0) ? true : false;

        });

        if (containsFolder) {
            args.cancel = true;
            alert("Folder upload is not allowed. Please select individual files.");
            return;
        }

        if (!batchGuid) setBatchGuid(uuidv4());
        setFileGuidMap((prev) => {
            const next = new Map(prev);
            for (const f of args.filesData) {
                const key = fileKey(f);
                if (!next.has(key)) next.set(key, uuidv4());
            }
            return next;
        });
    };


    //added by nilam
    useEffect(() => {
        if (
            companyFilesQueryResults?.data?.file &&
            !companyFilesQueryResults.loading
        ) {
            const incomingFiles = companyFilesQueryResults.data.file;
            const mergedFiles = incomingFiles.map((file) => ({
                ...file,
                isChecked: checkedIds.includes(file.id),
            }));
            setCompanyFiles(mergedFiles);
        }
    }, [companyFilesQueryResults.data, checkedIds]);

    const onCheckedChange = (event) => {
        const fileId = parseInt(event.target.id, 10);
        const isChecked = event.target.checked;
        setCheckedIds((prev) =>
            isChecked ? [...prev, fileId] : prev.filter((id) => id !== fileId)
        );

        setCompanyFiles((prevFiles) =>
            prevFiles.map((file) =>
                file.id === fileId ? { ...file, isChecked } : file
            )
        );
        // Optional: Update buttons
        const newCheckedCount = isChecked
            ? checkedIds.length + 1
            : checkedIds.length - 1;
        setDownloadAllDisabled(newCheckedCount === 0);
        setSelectAllChecked(newCheckedCount === companyFiles.length);
    };

    const onCheckAllChange = () => {
        const newChecked = !selectAllChecked;
        setSelectAllChecked(newChecked);
        // Update all files' isChecked
        const updatedFiles = companyFiles.map((file) => ({
            ...file,
            isChecked: newChecked,
        }));
        setCompanyFiles(updatedFiles);
        // Update checkedIds accordingly
        const updatedIds = newChecked ? updatedFiles.map((file) => file.id) : [];
        setCheckedIds(updatedIds);
        // Update download button state
        setDownloadAllDisabled(updatedIds.length === 0);
    };

    const handleSingleCheck = (id) => {
        const updatedFiles = companyFiles.map((file) =>
            file.id === id ? { ...file, isChecked: !file.isChecked } : file
        );
        setCompanyFiles(updatedFiles);
        const allChecked = updatedFiles.every((file) => file.isChecked);
        setSelectAllChecked(allChecked);
    };

    const downloadAllClick = () => {
        const fileIds = [...checkedIds]; // Array of selected file IDs
        if (fileIds.length === 0) {
            alert("Please select at least one file to download.");
            return;
        }
        setShowProgress(true);
        Axios.get(`${getBaseURL()}files/filedownload/${fileIds.join(",")}`, {
            ...config,
            headers: {
                ...config?.headers,
                Authorization: `Bearer ${currentUser.jwtIdToken.idToken}`,
            },
            responseType: "json",
            onDownloadProgress: (progressEvent) => {
                setProgress(0);
                const total =
                    progressEvent.total ||
                    progressEvent.target.getResponseHeader("content-length");
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / total
                );
                setProgress(percentCompleted);
            },
        })
            .then(async (response) => {
            
            if (response.data.fileName) {
            
                const link = document.createElement("a");
                link.href = response.data.fileName;
                const fileName =
                    response.data.fileName.split("/").pop();
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                } else {
                    const delay = (ms) =>
                        new Promise((resolve) => setTimeout(resolve, ms));
                
                    for (const url of response.data.fileNames) {
                
                        const link = document.createElement("a");
                        link.href = url;
                        const fileName = url.split("/").pop();
                        link.setAttribute("download", fileName);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        await delay(1000);
                    }
                }
                
                setShowProgress(false);
                setProgress(0);
            })
            .catch((error) => {
                console.error("Download failed:", error);
                setShowProgress(false);
                setProgress(0);
            });
    };
    // Resend password to users:
    const [resending, setResending] = useState({});

    const handleMenuOpen = (id) => (event) => {
        setMenuAnchorById((prev) => ({ ...prev, [id]: event.currentTarget }));
    };

    const handleMenuClose = (id) => () => {
        setMenuAnchorById((prev) => ({ ...prev, [id]: null }));
    };

    const handleResendClick = (item) => async () => {

        handleMenuClose(item.id)();
        try {
            setResending((prev) => ({ ...prev, [item.id]: true }));
            // Call resend function
            await handleResendPassword(item);
        } finally {
            setResending((prev) => ({ ...prev, [item.id]: false }));
        }
    };


    const handleResendPassword = async (file) => {

        const ok = window.confirm(
            `Resend password for "${file.fileName}" to users associated with this file?`
        );
        if (!ok) return;

        try {
            setResending((prev) => ({ ...prev, [file.id]: true }));


            const payload = { Id: file.id }


            await Axios.post(`${getBaseURL()}files/resend-password`, payload, config);

            setErrorSnackBarText(`Password has been resent for "${file.fileName}".`);
            setSnackBarOpen(true);
        } catch (e) {
            const msg =
                e?.response?.data?.message ||
                e?.message ||
                "Failed to resend password. Please try again.";
            setErrorSnackBarText(msg);
            setErrorSnackBarOpen(true);
        } finally {
            setResending((prev) => ({ ...prev, [file.id]: false }));
        }
    };
    
    const handleFileNameBlur = async () => {
    const trimmed = customFileName.trim();
    if (!trimmed) return;
    try {
        const res = await Axios.get(
            `${getBaseURL()}files/checkfilename/${encodeURIComponent(trimmed)}`,
            config
        );
        setFileNameError(
            res.data.exists ? "File name already exists. Please choose another name." : ""
        );
    } catch {
        // fail silently; final submit will still catch duplicates via the 409 response
    }
    };
    
    //  ADDED: Open/Close dialog handlers
    const handleOpenUploadDialog = (e) => {
        e?.currentTarget?.blur();
        if (!selectedCompany) {
            setSelectedRecipients([]);            // ✅ ensure clean state on open

            setOpenUploadDialog(true);

            setErrorSnackBarText("Please select a company first.");
            setErrorSnackBarOpen(true);
            return;
        }

        setOpenUploadDialog(true);
    };

    const handleCloseUploadDialog = () => {
        setOpenUploadDialog(false);
        setSubmitting(false);
        setBusinessReason("");
        setCustomFileName("");
        setFileNameError("");
        setSelectedRecipients([]);
        setAttemptedSubmit(false);
        try {
            uploaderRef.current?.clearAll();
        } catch { }
    };

    //  ADDED: Simple upload-and-wait helpers for the dialog uploader
    const uploadPendingCountRef = useRef(0);
    const uploadResolveRef = useRef(null);
    const uploadRejectRef = useRef(null);


    const startUploadAndWait = () => {
        const total = uploaderRef.current?.filesData?.length || 0;
        if (total === 0) {
            return Promise.resolve();
        }
        uploadPendingCountRef.current = total;
        return new Promise((resolve, reject) => {
            uploadResolveRef.current = resolve;
            uploadRejectRef.current = reject;
            try {
                uploaderRef.current?.upload();
            } catch (e) {
                uploadResolveRef.current = null;
                uploadRejectRef.current = null;
                reject(e);
            }
        });
    };

    const onDialogUploadSuccess = (args) => {


        if (uploadPendingCountRef.current > 0) {
            uploadPendingCountRef.current -= 1;
            if (uploadPendingCountRef.current === 0) {
                try {
                    uploaderRef.current?.clearAll();
                } catch { }
                const resolve = uploadResolveRef.current;
                uploadResolveRef.current = null;
                uploadRejectRef.current = null;
                resolve?.();
            }
        }
    };

    const onDialogUploadFailure = () => {
        const reject = uploadRejectRef.current;
        uploadResolveRef.current = null;
        uploadRejectRef.current = null;
        setErrorSnackBarText("Unable to upload the file. Please try again.");
        setErrorSnackBarOpen(true);
        reject?.(new Error("Upload failed."));
    };




    //  ADDED: Submit handler (validates, uploads, then posts approval data)
    const handleSubmitForApproval = async (event) => {
        if (event?.preventDefault) event.preventDefault();
        setAttemptedSubmit(true);

        const reason = (businessReason ?? "").trim();
        const recipients = Array.isArray(selectedRecipients) ? selectedRecipients : [];
        const filesCount = uploaderRef.current?.filesData?.length || 0;
        const enteredFileName = (customFileName ?? "").trim();

       if (!enteredFileName) {
        setErrorSnackBarText("Please enter a file name.");
        setErrorSnackBarOpen(true);
        return;
        }

        if (fileNameError) {
        setErrorSnackBarText(fileNameError);
        setErrorSnackBarOpen(true);
        return;
       }

        if (!reason) {
            setErrorSnackBarText("Please add a business reason before submitting.");
            setErrorSnackBarOpen(true);
            return;
        }
        if (recipients.length === 0) {
            setErrorSnackBarText("Please select at least one recipient.");
            setErrorSnackBarOpen(true);
            return;
        }
        if (filesCount === 0) {
            setErrorSnackBarText("Please select at least one file to upload.");
            setErrorSnackBarOpen(true);
            return;
        }

        try {
            setSubmitting(true);





            const fileData = {
              
                CompanyId: Number(selectedCompany),
                BusinessJustification: reason,
                Email: recipients,
                BaseUrl: window.location.origin,
                RequestedFileName: enteredFileName

            };

            await getFreshToken();          // fresh token before upload
await startUploadAndWait();
await getFreshToken();          // fresh token before merge

const mergeUrl = `${getBaseURL()}files/batches/${batchGuid}/merge`;
const postMerge = () =>
    Axios.post(mergeUrl, fileData, {
        headers: { Authorization: `Bearer ${tokenRef.current}` },
        timeout: 24000000,
    });

try {
    await postMerge();
} catch (err) {
    if (err?.response?.status === 401) {
        await getFreshToken();
        await postMerge();
    } else {
        throw err;
    }
}



            // Reuse existing snackbar (success)
            setErrorSnackBarText("Request submitted for approval.Email sent to manager.");
            setSnackBarOpen(true);

            handleCloseUploadDialog();
        } catch (e) {
            const msg =
                e?.response?.data?.message ||
                e?.message ||
                "Submission failed. Please try again.";
            setErrorSnackBarText(msg);
            setErrorSnackBarOpen(true);
            setOpenUploadDialog(true); // keep open for retry
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Container maxWidth={false} disableGutters={true} className={classes.root}>
            {userCompanies && userCompanies.length === 0 && (
                <Typography variant="h5">
                    You do not have access to any companies
                </Typography>
            )}
            {userCompanies && userCompanies.length > 0 ? (
                <Grid
                    container
                    alignItems="center"
                    justify="flex-start"
                    direction="row"
                >
                    <Grid item md={4}>
                        <div>
                            <Typography
                                variant="h5"
                                style={{
                                    display: "inline-block",
                                    paddingRight: "5px",
                                    marginTop: "15px",
                                }}
                            >
                                Company:
                            </Typography>
                            <Select value={selectedCompany} onChange={handleCompanyChange}>
                                {userCompanies.map((item, index) => {
                                    return (
                                        <MenuItem value={item.company.id} key={index}>
                                            {item.company.name}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </div>
                    </Grid>

                    {/*  ADDED — Upload button to open Approval Dialog (keeps old uploader intact) */}
                    <Grid item style={{ marginTop: 8, marginLeft: 12 }}>
                        {uploadFiles && (
                            <Button
                                color="primary"
                                variant="contained"
                                className={classes.button}
                                onClick={handleOpenUploadDialog}
                            >
                                Upload
                            </Button>
                        )}
                    </Grid>

                    {/* <Grid item md={2}></Grid> */}
                    {/* <Grid item md={6} className={classes.griditem}>
            {uploadFiles && (
              <UploaderComponent
                asyncSettings={asyncSettings}
                uploading={onFilesUploading}
                maxFileSize={1073741824000}
                chunkUploading={onChunkUpload}
                selected={onSelect}
                clearing={onClear}
                removing={onClear}
                actionComplete={onActionComplete}
                onFailure={onFailure}
              />
            )}
          </Grid> */}
                </Grid>
            ) : (
                <Typography variant="subtitle1">No Companies Found</Typography>
            )}
            {companyFiles.length > 0 ? (
                <div style={{ paddingTop: "10px" }}>
                    <div style={{ display: "flex" }}>
                        <span className={classes.wrapper} style={{ paddingRight: "25px" }}>
                            <label>
                                <Checkbox
                                    checked={selectAllChecked}
                                    onChange={onCheckAllChange}
                                    color="primary"
                                />
                                Select All
                            </label>
                        </span>
                        <span className={classes.wrapper}>
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={downloadAllClick}
                                disabled={checkedIds.length === 0}
                            >
                                Download
                            </Button>
                            {showProgress && (
                                <div style={{ marginTop: "10px" }}>
                                    <label> Download Progress</label>
                                    <progress value={progress} max="100" style={{ width: "100%" }} />
                                    <p>{progress}%</p>
                                </div>
                            )}
                        </span>
                    </div>
                </div>
            ) : (
                <Typography variant="subtitle1">Loading...</Typography>
            )}
            <div style={{ paddingTop: "10px" }}>
                {/* <div id='droparea' style={{ height: '400px', border: '1px solid black' }}></div> */}
                {!loadingFiles && !loadingCompanies ? (
                    <>
                        {companyFiles.length > 0 ? (
                            <div className={classes.cards}>
                                {companyFiles
                                    .filter((d) => d.id !== 0)
                                    .map((item, index) => {
                                        return (
                                            <Grow in={true} key={index}>
                                                <Card
                                                    className={`  ${classes.fileCard} ${item.downloading
                                                        ? classes.cardLoading
                                                        : classes.cardNotLoading
                                                        }`}
                                                >
                                                    <CardContent>

                                                        <div style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between"
                                                        }}>

                                                            <Typography variant="h6">{item.fileName}</Typography>
                                                            {/* Ellipsis menu */}
                                                            {item.encryptedPassword && item.encryptedPassword.trim() !== "" && (

                                                                <IconButton
                                                                    aria-label="more"
                                                                    aria-controls={`file-menu-${item.id}`}
                                                                    aria-haspopup="true"
                                                                    onClick={handleMenuOpen(item.id)}
                                                                    size="small"

                                                                >
                                                                    <MoreVertIcon />
                                                                </IconButton>

                                                            )}
                                                        </div>
                                                        <Menu
                                                            id={`file-menu-${item.id}`}
                                                            anchorEl={menuAnchorById[item.id] || null}
                                                            keepMounted
                                                            open={Boolean(menuAnchorById[item.id])}
                                                            onClose={handleMenuClose(item.id)}
                                                            getContentAnchorEl={null}      // v4 positioning fix
                                                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                                                        >
                                                            <MenuItem
                                                                onClick={handleResendClick(item)}
                                                                disabled={!!resending[item.id]}
                                                            >
                                                                {resending[item.id] ? (
                                                                    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                                                                        <CircularProgress size={16} /> Resending…
                                                                    </span>
                                                                ) : (
                                                                    "Resend Password"
                                                                )}
                                                            </MenuItem>
                                                        </Menu>
                                                        {item.encryptedPassword && item.encryptedPassword.trim() !== "" && (


                                                            <Tooltip
                                                                title={
                                                                    <Box>
                                                                        <Typography variant="subtitle2" sx={{ m: 0, mb: 0.5 }}>

                                                                            {String(item.originalFileNames || '')
                                                                                .split(';')
                                                                                .map((u, idx) => {
                                                                                    const t = u.trim();
                                                                                    if (!t) return null;
                                                                                    return <div key={idx}>{t}</div>;
                                                                                })}
                                                                        </Typography>
                                                                    </Box>
                                                                }>
                                                                <u>Original File Names</u>
                                                            </Tooltip>

                                                        )}
                                                        <Typography variant="subtitle1">
                                                            Added: {item.dateUploaded}
                                                        </Typography>
                                                        <div style={{ display: "flex" }}>
                                                            <Typography variant="subtitle1">
                                                                Expires: {item.expirationDate}
                                                            </Typography>

                                                            {/* Resend Password  */}
                                                            {/*<Button*/}
                                                            {/*  size="small"*/}
                                                            {/*  variant="outlined"*/}
                                                            {/*  color="primary"*/}
                                                            {/*  className={classes.button}*/}
                                                            {/*  onClick={() => handleResendPassword(item)}*/}
                                                            {/*  disabled={!!resending[item.id]}*/}
                                                            {/*  startIcon={resending[item.id] ? <CircularProgress size={16} /> : null}*/}
                                                            {/*>*/}
                                                            {/*  {resending[item.id] ? "Resending..." : "Resend Password"}*/}
                                                            {/*</Button>*/}

                                                            {item.downloading && (
                                                                <CircularProgress
                                                                    style={{
                                                                        margin: 0,
                                                                        padding: 0,
                                                                        marginLeft: "40%",
                                                                        marginBottom: "45%",
                                                                    }}
                                                                />
                                                            )}
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        style={{
                                                                            float: "right",
                                                                            marginLeft: "100%",
                                                                            marginTop: "-50%",
                                                                        }}
                                                                        id={item.id.toString()}
                                                                        checked={checkedIds.includes(item.id)} // ✅ Use checkedIds directly
                                                                        color="primary"
                                                                        onChange={onCheckedChange}
                                                                    />
                                                                }
                                                                label={item.name}
                                                            />
                                                        </div>
                                                    </CardContent>
                                                </Card>
                                            </Grow>
                                        );
                                    })}
                            </div>
                        ) : (
                            <Typography variant="subtitle1">
                                No Files Available test
                            </Typography>
                        )}
                    </>
                ) : null}
            </div>
            {/* <Typography variant="subtitle1">Loading...</Typography> */}

            {/*  ADDED — Approval Upload Dialog */}
            <Dialog
                open={openUploadDialog}
                onClose={handleCloseUploadDialog}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>Upload &amp; Submit for Approval</DialogTitle>
                <DialogContent dividers>
                    {/* Dialog Uploader (separate from inline uploader) */}
                    <UploaderComponent
                        ref={uploaderRef}
                        autoUpload={false}
                        directoryUpload={false}
                        maxFileSize={1073741824000}
                        multiple={true}
                        asyncSettings={asyncSettings}
                        selected={onSelect}
                        uploading={onFilesUploading}
                        chunkUploading={onChunkUpload}
                        success={onDialogUploadSuccess}
                        failure={onDialogUploadFailure}
                        removing={onDialogFileRemove}
                        clearing={onDialogClear}
                        showFileList={true}
                        cssClass="hide-syncfusion-actions"
                        buttons={{ clear: '', upload: '' }}
                    />
                    <Box mt={3}>
                        <Typography>
                             File Name:
                        </Typography>

                       <TextField
                        variant="outlined"
                        fullWidth
                        required
                        value={customFileName}
                        onChange={(e) => {
                            setCustomFileName(e.target.value);
                            setFileNameError("");
                        }}
                        onBlur={handleFileNameBlur}
                        placeholder="File Name"
                        error={(attemptedSubmit && !customFileName.trim()) || !!fileNameError}
                        helperText={
                            (attemptedSubmit && !customFileName.trim() && "File name is required") ||
                            fileNameError ||
                            ""
                        }
                    />
                    </Box>

                    {/* Inline validation for files */}
                    {attemptedSubmit &&
                        (uploaderRef.current?.filesData?.length || 0) === 0 && (
                            <Typography variant="body2" style={{ color: "#d32f2f", marginTop: 8 }}>
                                Please select at least one file to upload.
                            </Typography>
                        )}

                    {/* Business Reason */}
                    <Box mt={3}>
                        <Typography>Business Reason for Sharing Files:</Typography>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            multiline
                            rows={4}
                            value={businessReason}
                            onChange={(e) => setBusinessReason(e.target.value)}
                            error={attemptedSubmit && !businessReason.trim()}
                            helperText={
                                attemptedSubmit && !businessReason.trim()
                                    ? "Business reason is required"
                                    : ""
                            }
                        />
                    </Box>

                    {/* Recipients */}
                    <Box mt={3}>
                        <Typography variant="subtitle1" gutterBottom>
                            Once Approved, Email(s) Will Be Sent to:
                        </Typography>




                        <>
                            <FormGroup row>
                                {recipientEmails.map((email) => (
                                    <FormControlLabel
                                        key={email}
                                        control={
                                            <Checkbox
                                                checked={selectedRecipients.includes(email)}
                                                onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    setSelectedRecipients((prev) =>
                                                        checked
                                                            ? [...prev, email]
                                                            : prev.filter((x) => x !== email)
                                                    );
                                                }}
                                            />
                                        }
                                        label={email}
                                    />
                                ))}
                            </FormGroup>

                            {attemptedSubmit && selectedRecipients.length === 0 && (
                                <Typography
                                    variant="body2"
                                    style={{ color: "#d32f2f", marginTop: 8 }}
                                >
                                    Please select at least one recipient.
                                </Typography>
                            )}
                        </>

                    </Box>

                    {/* Buttons */}
                    <Box mt={3} display="flex" gap={2}>
                        <Button
                            onClick={handleSubmitForApproval}
                            color="primary"
                            variant="contained"
                            className={classes.button}
                            disabled={submitting}
                            type="button"
                        >
                            SUBMIT
                        </Button>

                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            onClick={handleCloseUploadDialog}
                            disabled={submitting}
                        >
                            Cancel
                        </Button>
                    </Box>

                    {/* Progress */}
                    {submitting && (
                        <Box mt={2}>
                            <LinearProgress />
                            <Typography variant="caption">Submitting...</Typography>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>

            {/* EXISTING Snackbars (unchanged) */}
            <Snackbar
                open={snackBarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert onClose={handleSnackbarClose} severity="success">
                    {errorSnackBarText}
                </Alert>
            </Snackbar>

            <Snackbar
                open={errorSnackBarOpen}
                autoHideDuration={5000}
                onClose={handleErrorSnackbarClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert onClose={handleErrorSnackbarClose} severity="error">
                    {errorSnackBarText}
                </Alert>
            </Snackbar>
            <div className={classes.Verbiage}>

                <Typography variant="body1" color="inherit" style={{ fontWeight: "bold" }}>
                    Files with extensions .zip,.7z,.gz are not allowed for upload. Also, Folder upload is not allowed.
                </Typography>

            </div>
        </Container>
    );
};
